import React from 'react'

const UncategorizePage = () => {
  return (
    <div>UncategorizePage</div>
  )
}

export default UncategorizePage